import gql from 'graphql-tag'

export const requestInviteToTeam = gql`
  mutation requestInviteToTeam($team_id: Float!, $workspace_id: Float!) {
    requestInviteToTeam(team_id: $team_id, workspace_id: $workspace_id) {
      status
      msg
      data
    }
  }
`
